<template lang="pug" >
div.kpidataCoupon
  button(v-for="(kpi, index) in listKpis"
    :value="kpi"
    :key="index"
    @click="selectKpi(kpi.type)" :class="selected === kpi.type ? 'activeC' : 'kpi-cardsC'")
    kpi-card(:ammount='kpi.ammount' :title='kpi.title' :color='kpi.color' :percentage='kpi.percentage')
</template>

<script>
import KpiCard from '@/components/loyalty/Coupons/KpiCard'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'KpiCardsAccounts',
  props: ['datagraf', 'tipCons', 'fechaHasta', 'appProgram'],
  components: { 'kpi-card': KpiCard },
  data () {
    return {
      listKpis: [
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.allAccounts'),
          percentage: 0,
          type: 'T',
          color: null
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.activeAccounts'),
          percentage: 0,
          type: 'A',
          color: '#79C5B4'
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.blockedAccounts'),
          percentage: 0,
          type: 'B',
          color: '#F7AC6F'
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.closedAccounts'),
          percentage: 0,
          type: 'C',
          color: '#E88AA2'
        }
      ],
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang',
      getFechaHasta: 'getFechaHasta'
    })
  },
  async mounted () {
    this.getAmountsAndPercentages()
  },
  methods: {
    ...mapActions(['getCOTCF']),
    selectKpi (object, callService) {
      this.selected = object
      // console.log(`change to '${object}'`)
      this.$emit('type-cons', { tipCons: object, refresh: callService })
    },
    async getAmountsAndPercentages () {
      this.getCOTCF().then(response => {
        // console.log('getCOTCF response', response)
        this.listKpis[0].ammount = String(response.registros.totalcuentas)
        this.listKpis[1].ammount = String(response.registros.totalcreadas)
        this.listKpis[2].ammount = String(response.registros.totalbloqueadas)
        this.listKpis[3].ammount = String(response.registros.totalcerradas)
        if (response.registros.totalcuentas !== 0) {
          this.listKpis[1].percentage = parseFloat((response.registros.totalcreadas / response.registros.totalcuentas * 100).toFixed(2))
          this.listKpis[2].percentage = parseFloat((response.registros.totalbloqueadas / response.registros.totalcuentas * 100).toFixed(2))
          this.listKpis[3].percentage = parseFloat((response.registros.totalcerradas / response.registros.totalcuentas * 100).toFixed(2))
        } else {
          this.listKpis[1].percentage = parseFloat('0')
          this.listKpis[2].percentage = parseFloat('0')
          this.listKpis[3].percentage = parseFloat('0')
        }
        this.selectKpi(this.tipCons ? this.tipCons : this.listKpis[0].type, true)
      }).catch(err => {
        console.log('getCLTCF response', err)
      })
    }
  },
  watch: {
    async getLang () {
      this.listKpis[0].title = this.$t('loyalty.analytics.allAccounts')
      this.listKpis[1].title = this.$t('loyalty.analytics.activeAccounts')
      this.listKpis[2].title = this.$t('loyalty.analytics.blockedAccounts')
      this.listKpis[3].title = this.$t('loyalty.analytics.closedAccounts')
    },
    async getFechaHasta (newData, oldData) {
      if (newData) {
        // console.log(`KPI getFechaHasta ${newData} ${oldData}`)
        // console.log(`KPI tipCons ${this.tipCons} fechaHasta ${this.fechaHasta}`)
        this.getAmountsAndPercentages()
      }
    },
    async appProgram (newData, oldData) {
      if (newData) {
        // console.log(`KPI getAppProgram ${newData} ${oldData}`)
        this.getAmountsAndPercentages()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
